/*
 * @since 2020-11-18 12:10:07
 * @author junbao <junbao@mymoement.com>
 */

import { hoistMethod } from 'amos';
import { ExternalActionHook } from './withDevTools';

export namespace __redux {
  export interface AnyReducer {
    (state: any, action: any): any;
  }

  export type AnyStore = {
    replaceReducer(nextReducer: AnyReducer): void;
  } & any;

  export interface AnyStoreEnhancer {
    (next: (reducer: AnyReducer, preloadedState?: any) => AnyStore): (
      reducer: AnyReducer,
      preloadedState?: any,
    ) => AnyStore;
  }
}

export interface AmosReduxDevToolsEnhancer extends __redux.AnyStoreEnhancer, ExternalActionHook {}

const dummyEnhancer: AmosReduxDevToolsEnhancer = Object.assign((next: any) => next, {
  subscribe: () => void 0,
});

export function createAmosReduxDevToolsEnhancer(disable?: boolean): AmosReduxDevToolsEnhancer {
  if (typeof process === 'object' && process.env.NODE_ENV === 'development') {
    return forceCreateAmosReduxDevToolsEnhancer(disable);
  }
  return dummyEnhancer;
}

export function forceCreateAmosReduxDevToolsEnhancer(disable?: boolean): AmosReduxDevToolsEnhancer {
  if (disable) {
    return dummyEnhancer;
  }
  const listeners: Array<(action: any) => void> = [];
  const enhancer: __redux.AnyStoreEnhancer = (next) => {
    return (reducer, preloadedState) => {
      let lastAction: any;
      const wrapReducer = (reducer: __redux.AnyReducer): __redux.AnyReducer => (state, action) => {
        lastAction = action;
        return reducer(state, action);
      };
      const store = next(wrapReducer(reducer), preloadedState);
      const { replaceReducer } = store;
      store.subscribe(() => {
        listeners.forEach((fn) => fn(lastAction));
      });
      store.replaceReducer = hoistMethod<__redux.AnyReducer>(replaceReducer, (nextReducer) =>
        replaceReducer(wrapReducer(nextReducer)),
      );
      return store;
    };
  };
  const subscribe: ExternalActionHook['subscribe'] = (fn) => {
    listeners.push(fn);
  };
  return Object.assign(enhancer, { subscribe });
}
